import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import ProgrammePage from './ProgrammePage';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyCessationProgramme } from './companyCessationApi';
import { PROGRAMME_BY_PATH, PROGRAMME_LABELS } from './cessationTheme';

/**
 * Company Cessation → one programme's page.
 *
 * Both programme routes render this component; the programme is the last
 * segment of the path. Two near-identical route wrappers would have said
 * nothing the URL doesn't already say.
 */
const CProgrammePage = () => {
  const location = useLocation();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const segment = location.pathname.split('/').filter(Boolean).pop();
  const programme = PROGRAMME_BY_PATH[segment] || 'puff';

  const fetcher = useCallback(
    () => fetchCompanyCessationProgramme(programme, department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [programme, isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{PROGRAMME_LABELS[programme] || 'Quit Programmes'} | Shoorah</title>
      </Helmet>
      <ProgrammePage
        programme={programme}
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
        department={department}
      />
    </div>
  );
};

export default CProgrammePage;
